class Homepage {
    init () {
        this.tabComponents();
    }

    tabComponents () {
        $('.js-hp-four-slider-tabs').slick({
            lazyLoad: "ondemand",
            slidesToShow: 4.2,
            slidesToScroll: 1,
            swipeToSlide: true,
            arrows: true,
            dots: false,
            autoplay: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.2,
                        slidesToScroll: 2,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        arrows: false,
                        dots: false
                    }
                }]
        });

        $('.hp-tabs ul.tabs li').on('click', function (e) {
            e.stopPropagation();
            var parent = $(e.currentTarget).closest('.hp-tabs');
            var tabId = $(this).data('tab');
            parent.find('ul.tabs li').removeClass('current');
            parent.find('.tab-content').removeClass('current');
            const $tab = $('.' + tabId);
            $(this).addClass('current');
            setTimeout(() => {
                $tab.addClass('current');
                $tab.find('.slick-slider').slick('setPosition');
            });
        });
        $('ul.tabs li').on('click', function (e) {
            var tabId = $(this).data('tab');
            $('ul.tabs li').removeClass('current');
            $('.tab-content').removeClass('current');
            const $tab = $('#' + tabId);
            $(this).addClass('current');
            $tab.addClass('current');
            $tab.find('.slick-slider').slick('setPosition');
        });
    }
}

const homepage = new Homepage();
export default homepage;
